import ImageURL from 'components/Image';

import * as S from './styles';

const FooterSecurity = () => (
  <S.Wrapper>
    <ImageURL
      data-testid="logo-site-blindado"
      src="/tcstore/images/logos/lp/logo-site-blindado.svg"
      alt="Logo de segurança Site Blindado"
      width={158}
      height={40}
    />

    <ImageURL
      data-testid="logo-trust-sign"
      src="/tcstore/images/logos/lp/logo-trust-sign.png"
      alt="Logo de segurança Trust Sign"
      width={158}
      height={40}
    />
  </S.Wrapper>
);

export default FooterSecurity;
